import { TransactionForm } from "../transactionform.model";

export class NetellerWithdrawalForm extends TransactionForm {
  constructor(customerProducts, paymentOptions) {
    super(customerProducts, paymentOptions);
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/neteller/neteller-withdrawal-form.model.js